export const getColorForRankChart = (idx) => {
  switch (idx) {
    case 1:
      return '#05c';
    case 0:
    case 2:
    default:
      return 'var(--color-blue-600)';
  }
};

export const getLeaderboardPayload = (
  pagination,
  userCode,
  leaderboardCode,
) => ({
  timestamp: new Date().getTime(),
  user_id: userCode,
  leaderboard_code: leaderboardCode,
  filters: '{}',
  next: pagination,
  sort_options: {
    points: 'desc',
  },
  ranking_list_view_type: 'all',
  source: 'web',
});
